import { Tab, Nav, Col, Row, Modal, Button } from 'react-bootstrap';
import Loader from "react-loader-spinner";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import ApplicationSettingsFormTranslation from './translations/ApplicationSettingsFormTranslation';
import { TextInput } from 'components/UI/ComplexComponents/TextInput';
import { getCookie, parseDMY } from 'components/Common/CommonFunctions';
import { ReactDataContext } from '@themost/react';
import UserService from 'services/UserService';

const DEFAULT_CALL_SUFFIX = "1";
const CALL_SUFFIX_OPTIONS = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];

function parseAcademicYearCall(rawValue) {
    const value = rawValue === undefined || rawValue === null ? "" : String(rawValue).trim();
    if (!value) {
        return { year: null, suffix: DEFAULT_CALL_SUFFIX };
    }

    const callMatch = value.match(/^(\d{4})-(\d)$/);
    if (callMatch && CALL_SUFFIX_OPTIONS.includes(callMatch[2])) {
        return { year: Number(callMatch[1]), suffix: callMatch[2] };
    }

    const legacyYearMatch = value.match(/^(\d{4})$/);
    if (legacyYearMatch) {
        return { year: Number(legacyYearMatch[1]), suffix: DEFAULT_CALL_SUFFIX };
    }

    return { year: null, suffix: DEFAULT_CALL_SUFFIX };
}

function formatAcademicYearCall(year, suffix) {
    if (!year) {
        return null;
    }
    const safeSuffix = CALL_SUFFIX_OPTIONS.includes(String(suffix)) ? String(suffix) : DEFAULT_CALL_SUFFIX;
    return `${year}-${safeSuffix}`;
}


export default function StudentStudiesList(props) {
    const [loader, setLoader] = useState(false);
    const [type, setType] = useState("long-term-studies");
    const [langCode, setLangCode] = useState(getCookie("lang") ? getCookie("lang") : "en")
    const [applicationData, setApplicationData] = useState();
    const [showYearPickerModal, setShowYearPickerModal] = useState(false);
    const [selectedCallSuffix, setSelectedCallSuffix] = useState(DEFAULT_CALL_SUFFIX);


    const context = new ReactDataContext(process.env.REACT_APP_API_SERVER);
    context.setBearerAuthorization(UserService.getToken());

    const fetchInitialData = async () => {

        try {
            setLoader(true);
            const applicationSettingsResponse = await context.model('ApplicationSettings').asQueryable().where("applicationType").equal(type).getItem();
            const parsedCall = parseAcademicYearCall(applicationSettingsResponse?.academicYear);
            setSelectedCallSuffix(parsedCall.suffix);
            setApplicationData({
                ...applicationSettingsResponse,
                academicYear: formatAcademicYearCall(parsedCall.year, parsedCall.suffix)
            });
            setLoader(false);
        } catch (err) {
            console.log(err)
        }

    }


    useEffect(() => {
        fetchInitialData();
    }, [type])


    function setFieldValue(setterFunc) {

        return function (item, value) {
            setterFunc({ ...applicationData, [item]: value })
        }
    }

    const parsedAcademicCall = parseAcademicYearCall(applicationData?.academicYear);
    const selectedCallYearDate = parsedAcademicCall.year ? new Date(parsedAcademicCall.year, 0, 1) : null;
    const callValue = formatAcademicYearCall(parsedAcademicCall.year, selectedCallSuffix) || "";

    const setAcademicYearWithSuffix = (year, suffix) => {
        setApplicationData({
            ...applicationData,
            academicYear: formatAcademicYearCall(year, suffix)
        });
    };

    const onCallSuffixChange = (event) => {
        const suffix = event.target.value;
        setSelectedCallSuffix(suffix);
        setAcademicYearWithSuffix(parsedAcademicCall.year, suffix);
    };

    const onCallYearSelect = (date) => {
        if (!date) {
            return;
        }
        setAcademicYearWithSuffix(date.getFullYear(), selectedCallSuffix);
        setShowYearPickerModal(false);
    };

    const renderSettingsForm = (type) => {
        return (
            <div className="containter">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card p-4">
                            <h3 className="text-center">{ApplicationSettingsFormTranslation("applicationType" + type, langCode)['label']}</h3>
                            <div className="row">
                                <div className='col-md-10'>
                                    {
                                        TextInput({
                                            //   parentSetValueSelected: setFieldValue(setApplicationData),
                                            parentValueSelected: applicationData?.applicationCounter,
                                            inputLabel: ApplicationSettingsFormTranslation("applicationCounter", langCode)['label'],
                                            componentId: "applicationCounter",
                                            disabled: true,
                                            type: "text",

                                        })
                                    }
                                </div>
                                <div className="col-md-2 mt-auto mb-auto">
                                    <button className="btn btn-primary btn-next p-2"
                                        onClick={(e) => {
                                            setApplicationData({ ...applicationData, applicationCounter: 1 })
                                        }
                                        }>{ApplicationSettingsFormTranslation("resetCounter", langCode)['label']}</button>
                                </div>
                            </div>
                            <div className="form-group">
                                <label for="identificationIssueDate">{ApplicationSettingsFormTranslation("applicationStart", langCode)['label']}</label>
                                <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control" popperPlacement='bottom'
                                    selected={applicationData?.applicationStart ? applicationData?.applicationStart : null}
                                    onChange={(e) => {
                                        if (e !== null) {
                                            setApplicationData({ ...applicationData, applicationStart: e })
                                        }
                                        else {
                                            setApplicationData({ ...applicationData, applicationStart: null })
                                        }
                                    }} />


                            </div>

                            <div className="form-group">
                                <label for="identificationIssueDate">{ApplicationSettingsFormTranslation("applicationStop", langCode)['label']}</label>
                                <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control" popperPlacement='bottom'
                                    selected={applicationData?.applicationStop ? applicationData?.applicationStop : null}
                                    onChange={(e) => {
                                        if (e !== null) {
                                            setApplicationData({ ...applicationData, applicationStop: e })
                                        }
                                        else {
                                            setApplicationData({ ...applicationData, applicationStop: null })
                                        }
                                    }} />


                            </div>

                            <div className="form-group">
                                <label for="applicationCall">{ApplicationSettingsFormTranslation("applicationYear", langCode)['label']}</label>
                                <div className="row">
                                    <div className="col-md-8 mb-2 mb-md-0">
                                        <input
                                            id="applicationCall"
                                            type="text"
                                            className="form-control"
                                            value={callValue}
                                            placeholder="YYYY-N"
                                            readOnly
                                            onClick={() => setShowYearPickerModal(true)}
                                            style={{ cursor: "pointer" }}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <select
                                            className="form-control"
                                            value={selectedCallSuffix}
                                            onChange={onCallSuffixChange}
                                        >
                                            {CALL_SUFFIX_OPTIONS.map((suffix) => (
                                                <option key={suffix} value={suffix}>{suffix}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex justify-content-center">

                                <button className="btn btn-primary btn-success btn-submit m-2"
                                    onClick={async () => {
                                        try {
                                            const result = await context.model('ApplicationSettings').save(applicationData);
                                            console.log(applicationData)
                                            alert("Application Settings Saved successfully")
                                        } catch (err) {
                                            console.log(err)
                                        }
                                    }
                                    }>{ApplicationSettingsFormTranslation("submit", langCode)['label']}</button>
                            </div>
                        </div>

                    </div>
                </div>
                <Modal show={showYearPickerModal} onHide={() => setShowYearPickerModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>{ApplicationSettingsFormTranslation("applicationYear", langCode)['label']}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="d-flex justify-content-center">
                        <DatePicker
                            inline
                            dateFormat="yyyy"
                            showYearPicker
                            selected={selectedCallYearDate}
                            onChange={onCallYearSelect}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowYearPickerModal(false)}>
                            {langCode === "gr" ? "Κλείσιμο" : "Close"}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
    const renderSideNav = () => {
        return (<Nav variant="pills" className="flex-column" activeKey={type}>
            <Nav.Item>
                <Nav.Link
                    eventKey={"long-term-studies"}
                    onClick={() => setType("long-term-studies")}>
                    Long Term Student Studies Application
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link
                    eventKey={"short-term-studies"}
                    onClick={() => setType("short-term-studies")}>
                    Short Term Student Studies Application

                </Nav.Link>
            </Nav.Item>

        </Nav >);
    }
    const switchCasesSteps = () => {
        switch (type) {
            case "long-term-studies":
                return <Tab.Pane eventKey={"long-term-studies"}>
                    {renderSettingsForm("Long")}
                </Tab.Pane>
            case "short-term-studies":
                return <Tab.Pane eventKey={"short-term-studies"}>
                    {renderSettingsForm("Short")}
                </Tab.Pane>

            default:
                return <h1>No content</h1>
        }
    }

    if (loader) {
        return (<div style={{
            position: 'absolute', left: '50%', top: '50%',
            transform: 'translate(-50%, -50%)'
        }}>
            <Loader
                className="spinner mx-auto"
                type="TailSpin"
                color="#3A435E"
                height={70}
                width={70}
            />
        </div>);
    } else {
        return <Tab.Container id="left-tabs" activeKey={type}>
            <Row>
                <Col sm={3}>
                    {renderSideNav()}
                </Col>
                <Col sm={9}>
                    {switchCasesSteps()}
                </Col>
            </Row>
        </Tab.Container>
    }
}